import styled from "styled-components";
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";

const AppliedFilterNameDefaultBox = styled.span`
    white-space: nowrap;
    color: ${props => props.theme.colors.brandPrimary};
`;

const AppliedFilterNameMrGreenBox = styled(AppliedFilterNameDefaultBox)`
    color: ${props => props.theme.colors.text};
`;

const AppliedFilterNameSIBox = styled(AppliedFilterNameDefaultBox)`
     ${({theme}) => theme.font.presets.light};
     color: ${props => props.theme.colors.textLight};
     text-transform: none;
     letter-spacing: normal;
`;

export const AppliedFilterNameBox = styledByTheme(AppliedFilterNameDefaultBox)
    .forSI(AppliedFilterNameSIBox)
    .forSICis(AppliedFilterNameSIBox)
    .forMrGreen(AppliedFilterNameMrGreenBox)
    .forMrGreenCis(AppliedFilterNameMrGreenBox).apply();
